import React from "react";
import { Badge, Alert } from "react-bootstrap";
import { CommonButton, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";

const Step2ReceiverList = ({ selectedReceivers, onToggleReceiver }) => {
  const mockData = [
    {
      id: "8397",
      name: "SparkMinds check duplicate name",
      contactNo: "+65 1231 231 2318",
      receiverType: "Individual",
      relationship: "Related company",
      bank: "ASIA UNITED BANK",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "10/03/2026\n17:07:18",
      status: "--",
    },
    {
      id: "8377",
      name: "Thuynga Check level limit",
      contactNo: "+65 1234 567 8900",
      receiverType: "Organization",
      relationship: "Customer",
      bank: "OMNIPAY, INC.",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "08/03/2026\n11:09:48",
      status: "Approved",
    },
    {
      id: "8375",
      name: "Thuy Nga Check limit",
      contactNo: "+65 1234 567 8901",
      receiverType: "Individual",
      relationship: "Spouse",
      bank: "OMNIPAY, INC.",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "06/03/2026\n17:54:15",
      status: "Approved",
    },
  ];

  const columns = [
    { label: "ID", key: "id", cellClassName: "align-middle" },
    {
      label: "Name",
      key: "name",
      cellClassName: "align-middle text-black fw-medium",
    },
    {
      label: "Contact No",
      key: "contactNo",
      cellClassName: "align-middle text-black fw-medium",
    },
    {
      label: "Receiver Type",
      key: "receiverType",
      cellClassName: "align-middle",
    },
    {
      label: "Relationship",
      key: "relationship",
      cellClassName: "align-middle",
    },
    { label: "Bank", key: "bank", cellClassName: "align-middle" },
    {
      label: "Correspondence Bank",
      key: "correspondenceBank",
      cellClassName: "align-middle text-center",
    },
    {
      label: "Delivery Method",
      key: "deliveryMethod",
      cellClassName: "align-middle fw-medium text-black",
    },
    {
      label: "Created Date",
      key: "createdDate",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: "align-middle text-muted fs-12",
    },
    {
      label: "Status",
      key: "status",
      cellClassName: "align-middle text-center",
      render: (item) =>
        item.status !== "--" ? (
          <Badge
            bg="success"
            className="bg-opacity-10 text-success border-0 px-2 py-1"
          >
            {item.status}
          </Badge>
        ) : (
          <span className="text-muted">--</span>
        ),
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center mb-4 gap-2">
        <div style={{ width: "250px" }}>
          <CommonInput placeholder="Enter receiver name" />
        </div>
        <CommonButton
          variant="outline"
          className="p-0 d-flex align-items-center justify-content-center"
          style={{ width: "40px", height: "40px", borderRadius: "8px" }}
        >
          <i className="flaticon-381-repeat-1"></i>
        </CommonButton>
        <CommonButton
          className="p-0 d-flex align-items-center justify-content-center"
          style={{
            width: "40px",
            height: "40px",
            backgroundColor: "var(--primary)",
            borderRadius: "8px",
          }}
        >
          <i className="fa fa-search text-white"></i>
        </CommonButton>
      </div>

      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body p-0">
          <DataTable
            columns={columns}
            data={mockData}
            showPagination={false}
            rowClassName={(item) =>
              selectedReceivers.includes(item.id)
                ? "bg-light-blue cursor-pointer"
                : "cursor-pointer"
            }
            onRowClick={(item) => onToggleReceiver(item)}
            minWidth="1200px"
          />
        </div>
      </div>

      {selectedReceivers.length > 0 && (
        <>
          <Alert
            variant="warning"
            className="py-2 border-1 mb-3 rounded d-flex align-items-center"
            style={{
              backgroundColor: "#FFFAEB",
              borderColor: "#FEDF89",
              color: "#B54708",
            }}
          >
            <i className="far fa-info-circle me-2"></i>
            Bank transfer payments made after 6 PM Friday, on weekends, or on
            public holidays will be processed on the next business day.
          </Alert>
          <div className="mb-4">
            <div className="text-muted fs-12 mb-2">Selected beneficiaries</div>
            <div className="d-flex flex-wrap gap-2">
              {mockData
                .filter((i) => selectedReceivers.includes(i.id))
                .map((item) => (
                  <div
                    key={item.id}
                    className="bg-white border text-black d-flex align-items-center px-3 py-1"
                    style={{
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "600",
                      borderColor: "#E2E8F0",
                    }}
                  >
                    {item.name}
                    <i
                      className="fa fa-times ms-2 cursor-pointer"
                      style={{ color: "#475467", fontSize: "16px" }}
                      onClick={() => onToggleReceiver({ id: item.id })}
                    ></i>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Step2ReceiverList;
